import { render, staticRenderFns } from "./platformAdvantage.vue?vue&type=template&id=1e61f66d&scoped=true&"
import script from "./platformAdvantage.vue?vue&type=script&lang=js&"
export * from "./platformAdvantage.vue?vue&type=script&lang=js&"
import style0 from "../pc.css?vue&type=style&index=0&id=1e61f66d&scoped=true&lang=css&"
import style1 from "../phone.css?vue&type=style&index=1&id=1e61f66d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61f66d",
  null
  
)

export default component.exports